module.exports = __webpack_public_path__ + "img/dates.599e65de.svg";